import {Dates, InvoicesLogic, InvoiceStatus, InvoiceType, Numeric, PaymentChannel, SystemRole, Translations, BicHelper} from "../../../_snowpack/link/dist/@salaxy/core/salaxy-lib-core.js";
import {Barcodes, QrCodes} from "../../../_snowpack/link/dist/@salaxy/reports/salaxy-lib-reports.js";
import {InvoiceCrudController} from "../../../_snowpack/link/dist/@salaxy/ng1/salaxy-lib-ng1.js";
export class InvoiceProController extends InvoiceCrudController {
  constructor(invoicesApi, uiHelpers, $location, $routeParams, invService, ajax, proService, session, $timeout, proApi, $sce) {
    super(invoicesApi, uiHelpers, $location, $routeParams, invService, ajax);
    this.invService = invService;
    this.proService = proService;
    this.session = session;
    this.$timeout = $timeout;
    this.proApi = proApi;
    this.$sce = $sce;
    this.statusFilterId = "all";
    this.queryYear = Dates.getToday();
    this.ownerNameFilter = "";
    this.invoiceEntityTypes = [
      {label: Translations.get("SALAXY.NG1.InvoicesComponent.all"), value: "all"},
      {label: Translations.get("SALAXY.ENUM.InvoiceType.net.label"), value: "net"},
      {label: Translations.get("SALAXY.ENUM.InvoiceType.pension.label"), value: "pension"},
      {label: Translations.get("SALAXY.ENUM.InvoiceType.tax.label"), value: "tax"},
      {label: Translations.get("SALAXY.ENUM.InvoiceType.unemployment.label"), value: "unemployment"},
      {label: Translations.get("SALAXY.ENUM.InvoiceType.union.label"), value: "union"}
    ];
    this.invoiceEntityType = this.invoiceEntityTypes.find((x) => x.value === "all");
    this.statusFilter = this.statusFilters.find((x) => x.value === "waitingConfirmation");
    this._allChannels = null;
    this.qrCodesCache = {};
    this.ownerFilter = (value) => {
      if (this.ownerNameFilter === "" && this.statusFilter.value === "all" && this.invoiceEntityType.value === "all") {
        return true;
      }
      if (this.invoiceEntityType.value !== "all" && value.invoiceType !== this.invoiceEntityType.value) {
        return false;
      }
      if (this.ownerNameFilter.length > 0 && value.ownerInfo.avatar.displayName.toLowerCase().indexOf(this.ownerNameFilter.toLowerCase()) === -1) {
        return false;
      }
      if (this.statusFilter.value === "all") {
        return true;
      }
      const statuses = {
        waitingConfirmation: [InvoiceStatus.Unread, InvoiceStatus.Read, InvoiceStatus.WaitingConfirmation],
        paid: [InvoiceStatus.Paid, InvoiceStatus.PaymentStarted, InvoiceStatus.Canceled],
        forecast: [InvoiceStatus.Forecast, InvoiceStatus.Preview]
      };
      if (statuses[this.statusFilter.value].indexOf(value.status) === -1) {
        return false;
      }
      return true;
    };
    this.getGroupDataReader = (group, status) => {
      return {
        read: (arr, message) => {
          const showConfirmation = () => {
            const warning = this.getEprWarning(group.invoices, status);
            if (warning) {
              return this.uiHelpers.showConfirm(Translations.get("SALAXY.PRO.InvoiceProComponent.reader.confirm.heading"), warning);
            }
            return Promise.resolve(true);
          };
          return showConfirmation().then((result) => {
            if (result) {
              group["isReading" + status] = true;
              const promises = group.invoices.map((x) => this.getInvoice(x, message, status));
              return Promise.all(promises).then((invoices) => {
                arr.push(...invoices.filter((i) => !!i));
                group["isReading" + status] = false;
                group.status = status;
                return;
              });
            } else {
              return;
            }
          });
        },
        getSepaData: (arr) => this.getSepaData(arr),
        getFinvoiceData: (arr) => this.getFinvoiceData(arr),
        getPdfData: (arr) => this.getPdfData(arr),
        exportLabel: null,
        disabled: () => false
      };
    };
    this.getGroupItemDataReader = (item, status) => {
      return {
        read: (arr, message) => {
          const showConfirmation = () => {
            const warning = this.getEprWarning([item], status);
            if (warning) {
              return this.uiHelpers.showConfirm(Translations.get("SALAXY.PRO.InvoiceProComponent.reader.confirm.heading"), warning);
            }
            return Promise.resolve(true);
          };
          return showConfirmation().then((result) => {
            if (result) {
              item["isReading" + status] = true;
              return this.getInvoice(item, message, status).then((data) => {
                if (data) {
                  arr.push(data);
                }
                item["isReading" + status] = false;
                return;
              });
            } else {
              return;
            }
          });
        },
        getSepaData: (arr) => this.getSepaData(arr),
        getFinvoiceData: (arr) => this.getFinvoiceData(arr),
        getPdfData: (arr) => this.getPdfData(arr),
        exportLabel: null,
        disabled: () => false
      };
    };
  }
  $onInit() {
    super.$onInit();
    this.loadData();
  }
  loadData() {
    const loading = this.uiHelpers.showLoading("SALAXY.UI_Terms.loading");
    this.loadAllInvoices().then((items) => {
      this.updateGroupedItems(items);
      loading.dismiss();
      this.$timeout();
    });
  }
  async loadAllInvoices() {
    const items = [];
    const loadItems = (nextPageLink = null) => {
      let options = {$filter: `data/channel eq '${this.getSepaChannel()}' and endAt ge ${Dates.getYear(this.queryYear)}-01-01 and endAt le ${Dates.getYear(this.queryYear)}-12-31`, $orderby: "endAt desc"};
      const queryString = nextPageLink?.indexOf("?") ?? -1;
      if (queryString >= 0) {
        const searchParams = new URLSearchParams(nextPageLink.substr(queryString));
        if (searchParams.get("$skip")) {
          options = {$skip: Number(searchParams.get("$skip")), $filter: `data/channel eq '${this.getSepaChannel()}' and endAt ge ${Dates.getYear(this.queryYear)}-01-01 and endAt le ${Dates.getYear(this.queryYear)}-12-31`, $orderby: "endAt desc"};
        }
      }
      return this.proApi.oDataSearchInvoices(options).then((data) => {
        items.push(...data.items);
        return data.nextPageLink ? loadItems(data.nextPageLink) : null;
      });
    };
    return loadItems().then(() => {
      return items;
    });
  }
  getSepaChannel() {
    return this.invService.defaultSepaChannel;
  }
  showGroupDialog(group) {
    this.uiHelpers.openEditDialog("/views/pro/modals/invoice-group-dialog.html", group, {parent: this}, "xl");
  }
  showInvoiceDialog(item) {
    this.uiHelpers.openEditDialog("/views/pro/modals/invoice-dialog.html", item, {parent: this}, "xl");
  }
  getGroupedItems() {
    return this.groupedItems;
  }
  updateGroupedItems(items) {
    this.groupedItems = [];
    items.forEach((l) => {
      const id = l.ownerId + l.entityType + l.status + l.data.dueDate + l.data.channel;
      let group = this.groupedItems.find((x) => x.id === id);
      if (!group) {
        group = {
          id,
          ownerInfo: l.ownerInfo,
          invoiceType: l.entityType,
          status: l.status,
          dueDate: l.data.dueDate,
          payment: 0,
          channel: l.data.channel,
          invoices: []
        };
        this.groupedItems.push(group);
      }
      group.payment += l.payment;
      group.invoices.push(l);
    });
  }
  getPdfUrl(item) {
    if (!item.pdfUrl) {
      item.pdfUrl = "#";
      this.proService.getToken(item.ownerId).then((cachedToken) => {
        item.pdfUrl = window.salaxy.config.apiServer + `/v03/api/invoices/${item.id}/content?inline=${false}&access_token=${encodeURIComponent(cachedToken.token)}`;
      });
    }
    return item.pdfUrl;
  }
  getQrCode(item) {
    if (!this.qrCodesCache[item.id]) {
      this.qrCodesCache[item.id] = "loading";
      this.generateQrCodeSvgForInvoice(item).then((qrCode) => {
        if (!qrCode) {
          this.qrCodesCache[item.id] = "error";
          this.$timeout();
          return this.qrCodesCache[item.id];
        } else {
          this.qrCodesCache[item.id] = qrCode;
          this.$timeout();
          return this.$sce.trustAsHtml(this.qrCodesCache[item.id]);
        }
      });
    }
    if (this.qrCodesCache[item.id] === "error") {
      return this.qrCodesCache[item.id];
    }
    return this.$sce.trustAsHtml(this.qrCodesCache[item.id]);
  }
  getBarcodeValue(item) {
    return Barcodes.getValue(item.otherPartyInfo.ibanNumber || "", item.reference || "", Dates.asDate(item.data.dueDate), Numeric.round(item.payment * 100, 0));
  }
  getBarcode(item) {
    if (!item.otherPartyInfo.ibanNumber || !item.otherPartyInfo.ibanNumber.toLowerCase().trim().startsWith("fi")) {
      return "";
    }
    const getDocumentAndSvgNode = () => {
      return {document, svgNode: document.createElementNS("http://www.w3.org/2000/svg", "svg")};
    };
    const result = Barcodes.createBarcode(getDocumentAndSvgNode, item.otherPartyInfo.ibanNumber || "", item.reference || "", Dates.asDate(item.data.dueDate), Numeric.round(item.payment * 100, 0), {
      width: 1.8,
      height: 32,
      displayValue: true,
      fontSize: 15
    });
    if (!result) {
      return "";
    }
    return this.$sce.trustAsHtml(new XMLSerializer().serializeToString(result));
  }
  copyBarcode(item) {
    navigator.clipboard.writeText(this.getBarcodeValue(item));
  }
  getChannelAvatar(channel) {
    return InvoicesLogic.getChannelAvatar(channel);
  }
  updateInvoiceGroupStatus(group, status) {
    const loading = this.uiHelpers.showLoading(Translations.get("SALAXY.UI_Terms.wait"));
    const reader = this.getGroupDataReader(group, status);
    reader.read([], null).then(() => {
      loading.dismiss();
    });
  }
  updateInvoiceGroupItemStatus(item, status) {
    const loading = this.uiHelpers.showLoading(Translations.get("SALAXY.UI_Terms.wait"));
    const reader = this.getGroupItemDataReader(item, status);
    reader.read([], null).then(() => {
      loading.dismiss();
    });
  }
  getAllChannels() {
    if (this.proService.session && this._allChannels === null) {
      const settings = this.proService.session.settings;
      let available = settings.paymentChannels || [];
      if (settings.defaultPaymentChannel) {
        available = available.filter((x) => x !== settings.defaultPaymentChannel);
        available.unshift(settings.defaultPaymentChannel);
      }
      if (available.indexOf(PaymentChannel.ZeroPayment) < 0) {
        available.push(PaymentChannel.ZeroPayment);
      }
      if (available.indexOf(PaymentChannel.Undefined) < 0) {
        available.push(PaymentChannel.Undefined);
      }
      this._allChannels = available.map((x) => InvoicesLogic.getChannelAvatar(x));
    }
    return this._allChannels;
  }
  sumInvoicePayments(invoices) {
    let sum = 0;
    invoices.forEach((invoice) => {
      sum += invoice.payment;
    });
    return sum;
  }
  getInvoice(item, message, status = null) {
    const account = this.proService.accounts.find((x) => x.id === item.ownerId);
    if (!account) {
      console.error("Account id not found: " + item.ownerId || "null/empty");
      return Promise.resolve(null);
    }
    const updateInvoiceStatus = (invoice, status2) => {
      if (invoice.header.status === status2) {
        return Promise.resolve(invoice);
      }
      return this.proService.postJSONFor(item.ownerId, `/v03/api/invoices/${item.id}/status/${status2}`, null);
    };
    return this.proService.getJSONFor(item.ownerId, `/v03/api/invoices/${item.id}`).then((readInvoice) => {
      if (status) {
        return updateInvoiceStatus(readInvoice, status).then((updatedInvoice) => {
          item.status = updatedInvoice.header.status;
          return updatedInvoice;
        });
      } else {
        return readInvoice;
      }
    });
  }
  async getPdfData(invoices) {
    const blobs = [];
    const loader = this.uiHelpers.showLoading("SALAXY.UI_Terms.loading");
    for (const [index, invoice] of invoices.entries()) {
      const ownerId = invoice.payer.avatar.id || "none";
      const blob = await this.proService.downloadFor(ownerId, "/v03/api/invoices/content", invoice, "blob");
      loader.setText(`${index}/${invoices.length}`);
      blobs.push(blob);
    }
    loader.dismiss();
    return blobs;
  }
  async getFinvoiceData(invoices) {
    const blobs = [];
    const loader = this.uiHelpers.showLoading("SALAXY.UI_Terms.loading");
    for (const [index, invoice] of invoices.entries()) {
      const ownerId = invoice.payer.avatar.id || "none";
      const blob = await this.proService.downloadFor(ownerId, "/v03/api/invoices/finvoice", invoice, "blob");
      loader.setText(`${index}/${invoices.length}`);
      blobs.push(blob);
    }
    loader.dismiss();
    return blobs;
  }
  getSepaData(invoices) {
    const ownerId = invoices.length ? invoices[0].payer.avatar.id || "none" : "none";
    return this.proService.downloadFor(ownerId, `/v03/api/invoices/sepa`, invoices, "text");
  }
  getEprWarning(items, status) {
    if (status === InvoiceStatus.Canceled) {
      for (const item of items) {
        if (item.status === InvoiceStatus.Paid && item.entityType == InvoiceType.Net && this.isDelayed(item.logicalDate)) {
          return `${Translations.get("SALAXY.PRO.InvoiceProComponent.eprWarning.canceled.text1")} 

 ${Translations.get("SALAXY.PRO.InvoiceProComponent.eprWarning.canceled.text2")}`;
        }
      }
    } else if (status === InvoiceStatus.Paid) {
      for (const item of items) {
        if (item.status !== InvoiceStatus.Paid && item.entityType == InvoiceType.Net && this.isDelayed(item.logicalDate)) {
          return Translations.get("SALAXY.PRO.InvoiceProComponent.eprWarning.paid.text");
        }
      }
    }
    return null;
  }
  isDelayed(salaryDate) {
    if (this.session.isInRole(SystemRole.Test)) {
      const officialDate = Dates.add(salaryDate ?? "today", 5, "day");
      const expiresAt = Dates.addWorkdays(officialDate, 0);
      const today = Dates.asDate("today");
      return today > expiresAt;
    }
    return false;
  }
  async generateQrCodeSvgForInvoice(item) {
    const svg = await QrCodes.getValue(BicHelper.getBicForIban(item.otherPartyInfo.ibanNumber.replace(/\s+/g, "")), item.otherPartyInfo.avatar.displayName, item.otherPartyInfo?.ibanNumber, item.reference, null, item.payment, item.endAt);
    return svg;
  }
}
InvoiceProController.$inject = [
  "Invoices",
  "UiHelpers",
  "$location",
  "$routeParams",
  "InvoicesService",
  "AjaxNg1",
  "ProService",
  "SessionService",
  "$timeout",
  "ProApi",
  "$sce"
];
